import { ClipboardCheck, FileText, Award, Search } from "lucide-react";
import ServizioDetailTemplate from "@/components/servizi/ServizioDetailTemplate";

const SERVIZI = [
  { icon: ClipboardCheck, titolo: "Accompagnamento nel percorso di ottenimento", desc: "Verifica di tutta la documentazione necessaria: DVR, nomina del rappresentante, formazioni obbligatorie, nominativo del medico competente, DURC e DURF." },
  { icon: FileText, titolo: "Verifica della documentazione", desc: "Controllo puntuale di ogni documento richiesto per l'ottenimento della patente a crediti." },
  { icon: Award, titolo: "Asseverazione finale", desc: "Predisposizione dell'asseverazione finale che porta al rilascio della patente a crediti." },
  { icon: Search, titolo: "Check-up gratuito", desc: "Verifica preliminare gratuita della documentazione aziendale, offerta su richiesta." },
];

export default function PatenteCreditiCantieriPage() {
  return (
    <ServizioDetailTemplate
      testId="patente-crediti-cantieri"
      categoriaLabel="Sicurezza"
      titolo="Patente a Crediti Cantieri"
      heroImage="https://images.unsplash.com/photo-1768158988512-ad31657fe5b8?w=1400&q=80&auto=format"
      heroImageAlt="Casco da lavoro giallo su un pallet in un'area di cantiere"
      leadText="La patente a crediti necessaria per operare nei cantieri temporanei o mobili."
      introText="Promo.Ter si occupa di seguire l'azienda in ogni fase della pratica per l'ottenimento della patente a crediti, dalla verifica della documentazione fino all'asseverazione finale che porta al rilascio della patente."
      servizi={SERVIZI}
      calloutBadge="Check-up gratuito su richiesta"
      ctaText="Contatta il nostro ufficio per avviare la pratica della patente a crediti cantieri."
      telefoni={["06.68437.606", "06.68437.530"]}
    />
  );
}
